import LanguageDetect from 'languagedetect';
import { useMemo } from 'react';

const lngDetector = new LanguageDetect();
lngDetector.setLanguageType('iso2');

const acceptedLangs = ['fr', 'nl', 'de', 'en'];

export const useDetectLanguage = (text: string | null | undefined) => {
  const detectedLanguages = useMemo(() => {
    if (!text) return;
    return lngDetector.detect(text, 2);
  }, [text]);

  const mostProbableLanguage = useMemo(() => {
    if (!detectedLanguages?.length) return;
    const [firstProb, secondProb] = detectedLanguages;
    if (acceptedLangs.includes(firstProb[0])) return firstProb[0];
    if (acceptedLangs.includes(secondProb[0])) return secondProb[0];
    return undefined;
  }, [detectedLanguages]);

  return { detectedLanguages, mostProbableLanguage };
};
